import Vue from 'vue'
import Router from 'vue-router'
const index = () => import('@/view/pc/index')
const searchList = resolve => require(['@/view/pc/searchList'], resolve);
// const searchList = () => import('@/view/pc/searchList')
const articleDetails = () => import('@/view/pc/articleDetails')
const latestResearch = () => import('@/view/pc/latestResearch')
const literatureList = () => import('@/view/pc/literatureList')
const blogList = () => import('@/view/pc/blogList')
// const textNewsDetails = resolve => require(['@/view/pc/textNewsDetails'], resolve);
const textNewsDetails = () => import('@/view/pc/textNewsDetails')
const myCollection = () => import('@/view/pc/myCollection')
const myLiterature = () => import('@/view/pc/myLiterature')
const myMessage = () => import('@/view/pc/myMessage')
const databaseList = () => import('@/view/pc/databaseList')
const collectionList = () => import('@/view/pc/collectionList')
const accountSettings = () => import('@/view/pc/accountSettings')
const siteSearch = () => import('@/view/pc/siteSearch')
const viewPdf = () => import('@/view/pc/viewPdf')
Vue.use(Router)

export default new Router({
  // mode: 'history',
  // base:'/',
  scrollBehavior: () => ({ y: 0 }),
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    //集成统一检索
    {
      path: '/searchList',
      name: 'searchList',
      component: searchList
    },
    //详情页
    {
      path: '/articleDetails',
      name: 'articleDetails',
      component: articleDetails
    },
    //参文引文列表页
    {
      path: '/literatureList',
      name: 'literatureList',
      component: literatureList
    },
    //最新研究
    {
      path: '/latestResearch',
      name: 'latestResearch',
      component: latestResearch
    },
    // 博客类的新闻列表
    {
      path: '/blogList', 
      name: 'blogList',
      component: blogList
    },
    // 文字类的公告详情
    {
      path: '/textNewsDetails', 
      name: 'textNewsDetails',
      component: textNewsDetails
    },
    // 我的收藏页面
    {
      path: '/myCollection', 
      name: 'myCollection',
      component: myCollection
    },
    // 我的申请的文献页面
    {
      path: '/myLiterature', 
      name: 'myLiterature',
      component: myLiterature
    },
    // 我的留言
    {
      path: '/myMessage', 
      name: 'myMessage',
      component: myMessage
    },
    // 数据库列表
    {
      path:'/databaseList',
      name:'databaseList',
      component: databaseList,
    },
    // 数据库列表
    {
      path:'/collectionList',
      name:'collectionList',
      component: collectionList,
    },
    // 账户设置
    {
      path:'/accountSettings',
      name:'accountSettings',
      component: accountSettings,
    },
    // 站内检索 列表页面
    {
      path:'/siteSearch',
      name:'siteSearch',
      component: siteSearch,
    },
    // 查看pdf页面
    {
      path:'/viewPdf',
      name:'viewPdf',
      component: viewPdf,
    },
     //此项配置要放在最后
     {
      path:'*',
      redirect:'/',
      
    },
  ],
  
})



// WEBPACK FOOTER //
// ./src/router/index.js